
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gACdd78entBS_45rfnstIKKgs_FjX_45xIeCT9vRAv_cLaHIMeta } from "/codebuild/output/src2566578667/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexIT2a7UewImrLhOu_DdzUvEVANWLHpdxfXdNIdpRnn6QMeta } from "/codebuild/output/src2566578667/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchfGdOpvsbaToNkMBUFM7MSBcjKPgAwAhVhREusDdNtIYMeta } from "/codebuild/output/src2566578667/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexCGkAvRwonEikTnOWHR8gyTlMq7eHiw4OcX_45AlXxLUiYMeta } from "/codebuild/output/src2566578667/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_937uJ3VlGFdW7oJv_t5hOdjllHyQOQ4tE2uOUnF_456SavkMeta } from "/codebuild/output/src2566578667/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as index24ynzwxUh4rWnN_w1Xlq3HwPZ4AzFRbpXTMTsq1sM74Meta } from "/codebuild/output/src2566578667/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93_45fCzKwhoXdfj6LZq5beckX2frCZsPcVemVNS3FX473sMeta } from "/codebuild/output/src2566578667/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexRSFEVxt6EZqKfwyIy33rMO8Kb0EjF4o3D7ZXJiLGYQoMeta } from "/codebuild/output/src2566578667/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93Mwf3TLe9o9lzh32E2mJ_N7u8fcB9D20uunFBhJYXODcMeta } from "/codebuild/output/src2566578667/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexJx0V6Z4_45m8wRfDIAXZOQ5hQ0D5gZtUsFhEnZMMob_45aMMeta } from "/codebuild/output/src2566578667/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexzpIkrqIIFj_S9b6zQfD_45rvJ63uYTL6A7xpRVrqFUPDMMeta } from "/codebuild/output/src2566578667/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src2566578667/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src2566578667/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src2566578667/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src2566578667/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src2566578667/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: index24ynzwxUh4rWnN_w1Xlq3HwPZ4AzFRbpXTMTsq1sM74Meta || {},
    component: () => import("/codebuild/output/src2566578667/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src2566578667/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexRSFEVxt6EZqKfwyIy33rMO8Kb0EjF4o3D7ZXJiLGYQoMeta || {},
    component: () => import("/codebuild/output/src2566578667/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src2566578667/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexJx0V6Z4_45m8wRfDIAXZOQ5hQ0D5gZtUsFhEnZMMob_45aMMeta || {},
    component: () => import("/codebuild/output/src2566578667/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexzpIkrqIIFj_S9b6zQfD_45rvJ63uYTL6A7xpRVrqFUPDMMeta || {},
    component: () => import("/codebuild/output/src2566578667/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]